// extracted by mini-css-extract-plugin
export default {"title":"o7gdGTgScZGFvEK6ILm2","form":"PYRldH5vfR0rHT7l3f9F","button":"q5WKk166aAm9lovz1ph9"};